<template>
  <!-- class="custom-tabbar" -->
  <div class="tabbar-container">
    <van-tabbar v-if="show" v-model="active" route placeholder @change="onChange">
      <van-tabbar-item>
        <template #icon>
          <div class="tabbar-item-content">
            <img
              v-show="active == 0"
              class="icon"
              :src="getImageUrlWithCDN_TEST('/tabbar/home-check.png')"
            />
            <img
              v-show="active != 0"
              class="icon"
              :src="getImageUrlWithCDN_TEST('/tabbar/home.png')"
            />
            <span :class="active == 0 ? 'checkColor' : 'defColor'">Começar</span>
          </div>
        </template>
      </van-tabbar-item>

      <van-tabbar-item>
        <template #icon>
          <div class="tabbar-item-content">
            <img class="icon" :src="getImageUrlWithCDN_TEST('/tabbar/activity.png')" />
            <span class="defColor">Promoção</span>
            <!-- <img class="icon" v-show="active == 1" :src="getImageUrlWithCDN_TEST('/tabbar/activity-check.png')" />
            <img class="icon" v-show="active != 1" :src="activity" />
            <span :class="active == 1 ? 'checkColor' : 'defColor'">Promoção</span> -->
          </div>
        </template>
      </van-tabbar-item>

      <van-tabbar-item>
        <template #icon>
          <div class="tabbar-item-content">
            <img
              v-show="active == 2"
              class="icon"
              :src="getImageUrlWithCDN_TEST('/tabbar/agent-check.png')"
            />
            <img
              v-show="active != 2"
              class="icon"
              :src="getImageUrlWithCDN_TEST('/tabbar/agent.png')"
            />
            <span :class="active == 2 ? 'checkColor' : 'defColor'">Ofertas</span>
          </div>
        </template>
      </van-tabbar-item>

      <!-- badge="3" replace to="/carteira" -->
      <van-tabbar-item>
        <template #icon>
          <div class="tabbar-item-content">
            <img
              v-show="hadToken"
              class="icon"
              :src="getImageUrlWithCDN_TEST('/tabbar/carteira.png')"
            />
            <span v-show="hadToken" class="defColor">Depósito</span>

            <img
              v-show="!hadToken"
              class="icon"
              :src="getImageUrlWithCDN_TEST('/tabbar/registro.png')"
            />
            <span v-show="!hadToken" class="defColor">Registro</span>
            <!-- <img class="icon" v-show="active == 3" :src="carteiraCheck" />
            <img class="icon" v-show="active != 3" :src="getImageUrlWithCDN_TEST('/tabbar/carteira.png')" />
            <span :class="active == 3 ? 'checkColor' : 'defColor'">Depósito</span> -->
          </div>
        </template>
      </van-tabbar-item>

      <!-- replace to="/profile" -->
      <van-tabbar-item>
        <template #icon>
          <div class="tabbar-item-content">
            <div class="icon-box">
              <img
                v-show="active == 4"
                class="icon"
                :src="getImageUrlWithCDN_TEST('/tabbar/Profile-check.png')"
              />
              <img
                v-show="active != 4"
                class="icon"
                :src="getImageUrlWithCDN_TEST('/tabbar/Profile.png')"
              />
            </div>
            <span :class="active == 4 ? 'checkColor' : 'defColor'">Perfil</span>
          </div>
        </template>
      </van-tabbar-item>
    </van-tabbar>
    <!-- Depósito 存款 弹窗 -->
    <Deposito ref="depositoRef" />
    <LoginRegisterPopup ref="LoginRegisterRef" />
  </div>
</template>

<script setup>
import { rootRouteList } from '@/config/routes'
import { isLogin } from '@/utils/auth'
import { STORAGE_TOKEN_KEY } from '@/stores/mutation-type'
// import { useRouter } from 'vue-router'
// import { useEventListener } from '@vueuse/core'
import { useUserStore } from '@/stores'
const depositoRef = ref()
const router = useRouter()
const userStore = useUserStore()
const hadToken = computed(() => {
  return !!userStore.userInfo.token
})
const active = ref(0)
const LoginRegisterRef = ref('')
// 定义路由名称到Tab索引的映射
const routeToIndex = {
  Home: 0,
  Promocao: 1,
  Activity: 2,
  Carteira: 3,
  Profile: 4,
}

const route = useRoute()

// 根据当前路由设置active状态
const setActiveTab = () => {
  if (route.name && Object.prototype.hasOwnProperty.call(routeToIndex, route.name)) {
    active.value = routeToIndex[route.name]
    sessionStorage.setItem('active', active.value.toString())
  }
}

// 监听路由变化
watch(
  () => route.name,
  () => {
    setActiveTab()
  },
  { immediate: true }
)

// // 监听 localStorage 变化
// useEventListener(window, 'storage', (event) => {
//   if (event.key === 'active') {
//     const newValue = parseInt(event.newValue, 10)
//     if (!isNaN(newValue) && newValue >= 0 && newValue <= 4) {
//       active.value = newValue
//     }
//   }
// })

onMounted(() => {
  // 初始化时从 localStorage 读取状态
  const savedActive = sessionStorage.getItem('active')
  if (savedActive !== null) {
    const parsedActive = parseInt(savedActive, 10)
    if (!isNaN(parsedActive) && parsedActive >= 0 && parsedActive <= 4) {
      active.value = parsedActive
    }
  } else if (hadToken.value) {
    setActiveTab()
  } else {
    active.value = 0
  }
})

const onChange = (index) => {
  if (!hadToken.value) {
    active.value = 0
    sessionStorage.setItem('active', '0')
    nextTick(() => {
      LoginRegisterRef.value?.openPopupRegLogin()
    })
    return
  }
  if (index == 1) {
    // active.value = routeToIndex[route.name] || 0
    // localStorage.setItem('active', active.value.toString())
    const PromocaoType = localStorage.getItem('PromocaoType')
    if (PromocaoType && PromocaoType !== undefined) {
      router.push({
        name: 'Promocao',
        query: {
          id: 123456,
          type: +PromocaoType,
        },
      })
    } else {
      router.push('/Promocao')
    }
    return
  } else if (index == 2) {
    const ActivityType = localStorage.getItem('ActivityType')
    if (ActivityType && ActivityType !== undefined) {
      router.push({
        name: 'Activity',
        query: {
          id: 123456,
          type: +ActivityType,
        },
      })
    } else {
      router.push('/activity')
    }
    return
  } else if (index == 3) {
    active.value = routeToIndex[route.name] || 0
    sessionStorage.setItem('active', active.value.toString())
    depositoRef.value?.openPopupDeposit()
    return
  } else if (index == 4) {
    active.value = routeToIndex[route.name] || 0
    sessionStorage.setItem('active', active.value.toString())
    router.replace('/profile')
    return
  } else {
    active.value = 0
    sessionStorage.setItem('active', '0')
    router.replace('/')
  }
}

const show = computed(() => {
  if (route.name && rootRouteList.includes(route.name)) {
    return true
  }
  return false
})
</script>
<style scoped lang="scss">
.tabbar-container {
  --van-tabbar-height: 70px;
  --van-tabbar-background: var(--tabbar-view-bg);
  --van-tabbar-item-active-background: var(--tabbar-menu-active-bg);
  --van-tabbar-item-text-color: var(--tabbar-menu-name);
  --van-tabbar-item-active-color: var(--tabbar-menu-name-checked);

  :deep(.van-tabbar),
  :deep(.van-tabbar__placeholder) {
    height: 70px;
  }

  :deep(.van-tabbar-item) {
    height: 70px;
  }
}
.checkColor {
  margin-top: 3px;
  font-size: 12px;
  color: var(--tabbar-menu-name-checked);
}
.defColor {
  margin-top: 3px;
  font-size: 12px;
}

.tabbar-item-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;

  .icon {
    width: 25px;
    height: 25px;
  }

  .icon-box {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 25px;
    height: 25px;

    .icon {
      width: 25px;
      height: 25px;
    }
  }
}
</style>
